module.exports = __webpack_public_path__ + "static/media/gen_img14.4f0ae500.png";